export const translations = {
  de: {
    // Common
    appName: "Kaufmanns Hub",
    login: "Anmelden",
    logout: "Abmelden",
    email: "E-Mail",
    password: "Passwort",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    add: "Hinzufügen",
    search: "Suchen",
    loading: "Laden...",
    noData: "Keine Daten vorhanden",
    confirm: "Bestätigen",
    success: "Erfolgreich",
    error: "Fehler",
    
    // Navigation
    dashboard: "Dashboard",
    myTasks: "Meine Aufgaben",
    assignedTasks: "Zugewiesene Aufgaben",
    checklists: "Checklisten",
    contacts: "Kontakte",
    updates: "Mitteilungen",
    settings: "Einstellungen",
    payroll: "Gehaltsabrechnung",
    users: "Benutzer",
    externalSystems: "Externe Systeme",
    salesCRM: "Sales CRM",
    invoicesIncoming: "Rechnungen Eingehend",
    invoicesOutgoing: "Rechnungen Ausgehend",
    jobPortal: "Jobportal",
    openClaw: "OpenClaw",
    inventory: "Inventar",
    projectMCSchedule: "Stundenplan Projekt MC",
    
    // Dashboard
    welcome: "Willkommen",
    personalTasks: "Persönliche Aufgaben",
    pendingTasks: "Ausstehende Aufgaben",
    completedTasks: "Erledigte Aufgaben",
    checklistProgress: "Checklisten-Fortschritt",
    recentUpdates: "Aktuelle Mitteilungen",
    quickActions: "Schnellaktionen",
    newTask: "Neue Aufgabe",
    newChecklist: "Neue Checkliste",
    newContact: "Neuer Kontakt",
    
    // Tasks
    taskTitle: "Aufgabentitel",
    taskDescription: "Beschreibung",
    deadline: "Frist",
    priority: "Priorität",
    status: "Status",
    assignTo: "Zuweisen an",
    high: "Hoch",
    medium: "Mittel",
    low: "Niedrig",
    pending: "Ausstehend",
    inProgress: "In Bearbeitung",
    completed: "Erledigt",
    
    // Checklists
    daily: "Täglich",
    monthly: "Monatlich",
    checklistTitle: "Checklisten-Titel",
    addItem: "Element hinzufügen",
    recurring: "Wiederkehrend",
    progress: "Fortschritt",
    
    // Contacts
    contactName: "Name",
    role: "Rolle",
    company: "Unternehmen",
    phone: "Telefon",
    notes: "Notizen",
    
    // Updates
    postUpdate: "Mitteilung veröffentlichen",
    updateTitle: "Titel",
    updateContent: "Inhalt",
    attachment: "Anhang",
    
    // Settings
    profile: "Profil",
    language: "Sprache",
    emailSettings: "E-Mail-Einstellungen",
    smtpServer: "SMTP-Server",
    smtpPort: "SMTP-Port",
    smtpEmail: "SMTP E-Mail",
    smtpPassword: "SMTP Passwort",
    configureSmtp: "SMTP konfigurieren",
    smtpConfigured: "SMTP konfiguriert",
    smtpNotConfigured: "SMTP nicht konfiguriert",
    
    // Notifications
    notifications: "Benachrichtigungen",
    markAllRead: "Alle als gelesen markieren",
    noNotifications: "Keine Benachrichtigungen",
    
    // Roles
    admin: "Administrator",
    manager: "Manager",
    employee: "Mitarbeiter",
    
    // Messages
    loginSuccess: "Erfolgreich angemeldet",
    loginError: "Anmeldung fehlgeschlagen",
    taskCreated: "Aufgabe erstellt",
    taskUpdated: "Aufgabe aktualisiert",
    taskDeleted: "Aufgabe gelöscht",
    checklistCreated: "Checkliste erstellt",
    contactCreated: "Kontakt erstellt",
    updatePosted: "Mitteilung veröffentlicht",
    smtpSaved: "SMTP-Einstellungen gespeichert",
    profileUpdated: "Profil aktualisiert",
  },
  
  en: {
    // Common
    appName: "Kaufmanns Hub",
    login: "Login",
    logout: "Logout",
    email: "Email",
    password: "Password",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    search: "Search",
    loading: "Loading...",
    noData: "No data available",
    confirm: "Confirm",
    success: "Success",
    error: "Error",
    
    // Navigation
    dashboard: "Dashboard",
    myTasks: "My Tasks",
    assignedTasks: "Assigned Tasks",
    checklists: "Checklists",
    contacts: "Contacts",
    updates: "Updates",
    settings: "Settings",
    payroll: "Payroll",
    users: "Users",
    externalSystems: "External Systems",
    salesCRM: "Sales CRM",
    invoicesIncoming: "Incoming Invoices",
    invoicesOutgoing: "Outgoing Invoices",
    jobPortal: "Job Portal",
    openClaw: "OpenClaw",
    inventory: "Inventory",
    projectMCSchedule: "Schedule Project MC",
    
    // Dashboard
    welcome: "Welcome",
    personalTasks: "Personal Tasks",
    pendingTasks: "Pending Tasks",
    completedTasks: "Completed Tasks",
    checklistProgress: "Checklist Progress",
    recentUpdates: "Recent Updates",
    quickActions: "Quick Actions",
    newTask: "New Task",
    newChecklist: "New Checklist",
    newContact: "New Contact",
    
    // Tasks
    taskTitle: "Task Title",
    taskDescription: "Description",
    deadline: "Deadline",
    priority: "Priority",
    status: "Status",
    assignTo: "Assign to",
    high: "High",
    medium: "Medium",
    low: "Low",
    pending: "Pending",
    inProgress: "In Progress",
    completed: "Completed",
    
    // Checklists
    daily: "Daily",
    monthly: "Monthly",
    checklistTitle: "Checklist Title",
    addItem: "Add Item",
    recurring: "Recurring",
    progress: "Progress",
    
    // Contacts
    contactName: "Name",
    role: "Role",
    company: "Company",
    phone: "Phone",
    notes: "Notes",
    
    // Updates
    postUpdate: "Post Update",
    updateTitle: "Title",
    updateContent: "Content",
    attachment: "Attachment",
    
    // Settings
    profile: "Profile",
    language: "Language",
    emailSettings: "Email Settings",
    smtpServer: "SMTP Server",
    smtpPort: "SMTP Port",
    smtpEmail: "SMTP Email",
    smtpPassword: "SMTP Password",
    configureSmtp: "Configure SMTP",
    smtpConfigured: "SMTP Configured",
    smtpNotConfigured: "SMTP Not Configured",
    
    // Notifications
    notifications: "Notifications",
    markAllRead: "Mark all as read",
    noNotifications: "No notifications",
    
    // Roles
    admin: "Administrator",
    manager: "Manager",
    employee: "Employee",
    
    // Messages
    loginSuccess: "Successfully logged in",
    loginError: "Login failed",
    taskCreated: "Task created",
    taskUpdated: "Task updated",
    taskDeleted: "Task deleted",
    checklistCreated: "Checklist created",
    contactCreated: "Contact created",
    updatePosted: "Update posted",
    smtpSaved: "SMTP settings saved",
    profileUpdated: "Profile updated",
  },
  
  fr: {
    // Common
    appName: "Kaufmanns Hub",
    login: "Connexion",
    logout: "Déconnexion",
    email: "E-mail",
    password: "Mot de passe",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    add: "Ajouter",
    search: "Rechercher",
    loading: "Chargement...",
    noData: "Aucune donnée disponible",
    confirm: "Confirmer",
    success: "Succès",
    error: "Erreur",
    
    // Navigation
    dashboard: "Tableau de bord",
    myTasks: "Mes tâches",
    assignedTasks: "Tâches assignées",
    checklists: "Listes de contrôle",
    contacts: "Contacts",
    updates: "Actualités",
    settings: "Paramètres",
    payroll: "Paie",
    users: "Utilisateurs",
    externalSystems: "Systèmes externes",
    salesCRM: "CRM Ventes",
    invoicesIncoming: "Factures entrantes",
    invoicesOutgoing: "Factures sortantes",
    jobPortal: "Portail emploi",
    openClaw: "OpenClaw",
    inventory: "Inventaire",
    
    // Dashboard
    welcome: "Bienvenue",
    personalTasks: "Tâches personnelles",
    pendingTasks: "Tâches en attente",
    completedTasks: "Tâches terminées",
    checklistProgress: "Progression des listes",
    recentUpdates: "Dernières actualités",
    quickActions: "Actions rapides",
    newTask: "Nouvelle tâche",
    newChecklist: "Nouvelle liste",
    newContact: "Nouveau contact",
    
    // Tasks
    taskTitle: "Titre de la tâche",
    taskDescription: "Description",
    deadline: "Échéance",
    priority: "Priorité",
    status: "Statut",
    assignTo: "Assigner à",
    high: "Haute",
    medium: "Moyenne",
    low: "Basse",
    pending: "En attente",
    inProgress: "En cours",
    completed: "Terminé",
    
    // Checklists
    daily: "Quotidien",
    monthly: "Mensuel",
    checklistTitle: "Titre de la liste",
    addItem: "Ajouter un élément",
    recurring: "Récurrent",
    progress: "Progression",
    
    // Contacts
    contactName: "Nom",
    role: "Rôle",
    company: "Entreprise",
    phone: "Téléphone",
    notes: "Notes",
    
    // Updates
    postUpdate: "Publier une actualité",
    updateTitle: "Titre",
    updateContent: "Contenu",
    attachment: "Pièce jointe",
    
    // Settings
    profile: "Profil",
    language: "Langue",
    emailSettings: "Paramètres e-mail",
    smtpServer: "Serveur SMTP",
    smtpPort: "Port SMTP",
    smtpEmail: "E-mail SMTP",
    smtpPassword: "Mot de passe SMTP",
    configureSmtp: "Configurer SMTP",
    smtpConfigured: "SMTP configuré",
    smtpNotConfigured: "SMTP non configuré",
    
    // Notifications
    notifications: "Notifications",
    markAllRead: "Tout marquer comme lu",
    noNotifications: "Aucune notification",
    
    // Roles
    admin: "Administrateur",
    manager: "Manager",
    employee: "Employé",
    
    // Messages
    loginSuccess: "Connexion réussie",
    loginError: "Échec de la connexion",
    taskCreated: "Tâche créée",
    taskUpdated: "Tâche mise à jour",
    taskDeleted: "Tâche supprimée",
    checklistCreated: "Liste créée",
    contactCreated: "Contact créé",
    updatePosted: "Actualité publiée",
    smtpSaved: "Paramètres SMTP enregistrés",
    profileUpdated: "Profil mis à jour",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.de[key] || key;
};
